<template>
    <v-dialog v-model="dialog" max-width="600px">
        <v-card>
            <v-card-title
                class="text-h5 aviso"
                style="
                    justify-content: center;
                    background: #1d2735;
                    color: white;
                "
            >
                Buscar Cliente
            </v-card-title>
            <v-card-text style="text-align: center">
                <v-row style="padding-top: 1rem">
                    <v-col cols="12" md="6">
                        <clienteSelect
                            label="Nombre"
                            dense
                            outlined
                            v-model="cliente"
                        ></clienteSelect>
                    </v-col>
                    <v-col cols="12" md="6">
                        <clienteSelect
                            label="DNI/CIF"
                            dense
                            item-text="cif"
                            outlined
                            v-model="cliente"
                        ></clienteSelect>
                    </v-col>
                    <v-col cols="12" md="6">
                        <clienteSelect
                            label="Teléfono"
                            dense
                            item-text="telefono"
                            outlined
                            v-model="cliente"
                        ></clienteSelect>
                    </v-col>
                    <v-col cols="12" md="6">
                        <clienteSelect
                            label="Email"
                            item-text="email"
                            dense
                            outlined
                            v-model="cliente"
                        ></clienteSelect>
                    </v-col> </v-row
            ></v-card-text>
            <v-card-actions class="pt-3">
                <v-spacer></v-spacer>

                <v-btn color="success" large @click="Seleccionar()"
                    >Seleccionar</v-btn
                >

                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import clienteSelect from "../../../components/general/clienteSelect.vue";

export default {
    components: {
        clienteSelect,
    },
    props: ["value"],
    data() {
        return {
            dialog: false,
            cliente: null,
        };
    },
    watch: {
        dialog(val) {
            this.$emit("input", val);
        },
        value(val) {
            this.dialog = val;
        },
    },
    created() {},
    methods: {
        async Seleccionar() {
            const res = await axios.get(`api/getcliente/${this.cliente}`);
            const cliente = res.data;
            this.dialog = false;
            this.$emit("selected", cliente);
        },
    },
    computed: {},
};
</script>
